<template>
  <b-modal id="modal-dialog" ref="modal-dialog" size="xl" :title="title" @hidden="clearModalData">
    <!-- Modal body for all modals -->
    <p class="my-4" v-if="this.body && this.body.length > 0">{{ this.body }}</p>
    <!-- file picker modal -->
    <MediaViewer v-if="show" :targetPath="pickerPath" @route-update="pickerPath = $event.params.path" :isPicker="true"
      :multiPick="true" :pickerFoldersOnly="pickerFolders" :pickedFilesArray="pickedFilesArray"
      :hideFolder="folderIgnoreId" :view="'list'" :orientation="orientation"
      @current-folder-update="pickerFolderValue = $event.id" @file-clicked="selectFile" />
    <!-- modal buttons -->
    <div slot="modal-footer" class="w-100">
      <b-button variant="primary" v-if="confirmText" class="float-right mx-2" @click="modalConfirm">{{ confirmText
        }}</b-button>
      <b-button variant="light" v-if="cancelText" class="float-right mx-2" @click="modalCancel">{{ cancelText
        }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import MediaViewer from '@/components/MediaViewer.vue';
import mediaMixin from '@/views/admin/media/mediaMixin';

export default {
  mixins: [mediaMixin],
  components: {
    MediaViewer,
  },
  data() {
    return {
      show: false,
      title: '',
      body: '',
      cbConfirm: null,
      cbCancel: null,
      confirmText: '',
      cancelText: '',
      // file picker specifics
      pickerFolders: false,
      pickerPath: '',
      pickerFolderValue: null,
      folderIgnoreId: null,
      orientation: null,
      multiPick: true,
      pickedFilesArray: [],
      dir: null,
    };
  },
  created() {
    this.$root.$on('modal-show-file-picker', this.showModal);
  },
  beforeDestroy() {
    this.$root.$off('modal-show-file-picker', this.showModal);
  },
  methods: {
    showModal({
      title,
      body,
      cbConfirm,
      cbCancel,
      confirmText,
      cancelText,
      pickerFolders,
      folderIgnoreId,
      orientation,
      multiPick,
      dir,
    }) {
      this.show = true;
      this.title = title;
      this.body = body;
      this.cbConfirm = cbConfirm || null;
      this.cbCancel = cbCancel || null;
      this.confirmText = confirmText;
      this.cancelText = cancelText;
      this.filesArray = [];
      this.pickerFolders = pickerFolders;
      this.pickerPath = '';
      this.pickerFolderValue = null;
      this.folderIgnoreId = folderIgnoreId;
      this.dir = dir;
      this.orientation = orientation; // 0 - landscape, 1 - portrait
      this.multiPick = multiPick;
      this.pickedFilesArray = [];
      this.$refs['modal-dialog'].show();
    },
    hideModal() {
      this.$refs['modal-dialog'].hide();
    },
    clearModalData() {
      this.show = false;
      this.title = null;
      this.body = null;
      this.cbConfirm = null;
      this.cbCancel = null;
      this.confirmText = null;
      this.cancelText = null;
      this.filesArray = [];
      this.pickerFolders = null;
      this.pickerPath = '';
      this.pickerFolderValue = null;
      this.folderIgnoreId = null;
      this.dir = null;
      this.orientation = null; // 0 - landscape, 1 - portrait
      this.multiPick = null;
      this.pickedFilesArray = [];
    },
    modalConfirm() {
      if (this.cbConfirm) {
        if (this.pickerFolders) this.cbConfirm(this.pickerFolderValue);
        else if (!this.pickerFolders) this.cbConfirm(this.pickedFilesArray);
      }
      this.hideModal();
    },
    modalCancel() {
      if (this.cbCancel) this.cbCancel();
      this.hideModal();
    },
    selectFile($event) {
      if (!this.pickedFilesArray.find(e => e.id === $event.id)) {
        this.pickedFilesArray.push($event);
      } else {
        this.pickedFilesArray = this.pickedFilesArray.filter(e => e.id !== $event.id);
      }
      if (!this.multiPick) {
        this.pickedFilesArray.push($event);
        this.modalConfirm();
      }
    },
  },
};
</script>
